<template>
  <b-card>
    <h4>Empresa: {{ nomeEmpresa }}</h4>
    <mensagens-list
      id="mensagensList"
      ref="mensagensList"
      :botoes-opcoes="botoesOption"
      :visualizacao-opcoes="visualizacao"
      :filtros="filtros"
      :filtros-rapidos="filtrosRapidos"
      :tem-filtro-extra="isFiltroNovoNoMonitor"
      ultima-rota="caixapostal-view"
      filtro-de-para
      @carregado="atualizaNomeEmpresa"
    >
      <template
        v-if="isFiltroNovoNoMonitor"
        slot="filtro-extra"
      >
        <filtro-rapido
          ref="filtroRapido"
          :filtros="filtroRapidoSecundario"
          :filtro-atual="filtroAtualSecundario"
          filtro-nome="Periodo mensagem nova"
          @selecionado="$refs.mensagensList.aplicarFiltroRapido({...$event, queryName: 'dias', colunas: ['NovasNoMonitorSecundario'] }, false)"
        />
      </template>

      <template
        slot="custom"
        slot-scope="{ props} "
      >
        <span
          v-if="['assunto', 'remetente', 'enviadoEm', 'dataPrimeiraLeitura', 'consultadoEm'].includes(props.column.field)"
          @click.stop="props.column.field === 'assunto' && abrirMensagens(props.row)"
        >
          <span
            :style="{ fontWeight: props.row.mensagemLida === false ? 'bold' : 'normal' }"
          >
            {{ props.formattedRow[props.column.field] }}
          </span>
        </span>
        <span
          v-if="props.column.field === 'mensagemNova'"
        >
          <b-badge
            v-if="props.row.mensagemLida === false"
            :style="{
              backgroundColor:
                props.row.mensagemNova === 'amarelo'
                  ? 'rgba(217, 175, 11, 0.3)' // amarelo translúcido
                  : props.row.mensagemNova === 'azul'
                    ? 'rgba(16, 69, 171, 0.3)' // azul translúcido
                    : props.row.mensagemNova === 'vermelho'
                      ? 'rgba(220, 53, 69, 0.3)' // vermelho translúcido
                      : 'rgba(108, 117, 125, 0.3)', // cinza translúcido
              color:
                props.row.mensagemNova === 'amarelo'
                  ? '#b48a00' // amarelo escuro
                  : props.row.mensagemNova === 'azul'
                    ? '#0d2e91' // azul escuro
                    : props.row.mensagemNova === 'vermelho'
                      ? '#b8222d' // vermelho escuro
                      : '#4a4a4a', // cinza escuro
            }"
            class="badge-size-p"
          >
            Nova no Monitor
          </b-badge>

          <span v-else> - </span>
        </span>
        <span
          v-if="props.column.field === 'relevante'"
          class="d-block"
          style="text-align: center;"
        >
          <font-awesome-icon
            v-if="props.row[props.column.field]== true"
            icon="fa-solid fa-exclamation"
            style="color:red;font-size: 16px;"
          />
          <span v-else> - </span>
        </span>

        <span
          v-if="props.column.field === 'lido'"
          class="d-block"
          style="text-align: center;font-size: 16px;"
        >
          <feather-icon
            v-if="props.row[props.column.field] == true"
            icon="CheckIcon"
            style="font-size: 16px;color:green"
          />
          <font-awesome-icon
            v-else
            icon="fa-solid fa-xmark"
            style="color:red;font-size: 16px;"
          />
        </span>
      </template>

      <template
        slot="acoes"
        slot-scope="{ props }"
      >
        <div class="d-flex align-items-center">
          <span
            v-b-tooltip.hover
            :title="props.row.mensagem || abilityUpdate ? 'Visualizar mensagens' : 'Usuário não possui permissão'"
          >
            <b-btn
              variant="none"
              class="text-primary btn-none"
              style="padding: 0.3rem;"
              :disabled="!props.row.mensagem && !abilityUpdate"
              @click="abrirMensagens(props.row)"
            >
              <font-awesome-icon
                v-if="props.row.mensagem"
                icon="fa-solid fa-envelope-open-text"
              />
              <font-awesome-icon
                v-else
                icon="fa-solid fa-envelope"
              />
            </b-btn>
          </span>

          <b-btn
            v-b-tooltip.hover
            title="Observação"
            variant="none"
            class="btn-none"
            style="padding: 0.2rem;"
            @click="openModalObservacao(props.row)"
          >
            <font-awesome-icon
              icon="fa-regular fa-message"
              :class="{
                'text-success': props.row.todasObservacoesLidas,
                'text-warning': !props.row.todasObservacoesLidas && props.row.temObservacoesNaoLidas,
                'text-primary': !props.row.todasObservacoesLidas && !props.row.temObservacoesNaoLidas
              }"
            />
          </b-btn>

          <b-btn
            v-b-tooltip.hover
            title="Enviar por e-mail"
            variant="none"
            class="btn-none icone-acao m-0 p-0"
            style="padding: 0.4rem;"
            @click="openModalEnviarMensagem(props.row)"
          >
            <feather-icon
              icon="SendIcon"
              class="text-primary"
              size="17"
            />
          </b-btn>

          <modal-whatsapp
            :disabled="!props.row.lido"
            tipo-rotina="Mensagens E-CAC"
            :row="props.row"
            :is-mensagem="true"
          />
        </div>
      </template>
    </mensagens-list>

    <envio-email
      ref="modalEnvioEmail"
      :title="`Enviar mensagem Caixa Postal ${nomeEmpresa}`"
      :sugestao="emailEmpresa"
      :sugestao-email-adicional="emailAdicionalEmpresa"
      @enviarEmail="enviarMensagem"
    />

    <modal-caixa-postal
      :linha="linha"
      @enviarMensagem="openModalEnviarMensagem"
    />
    <loading
      :show-cancel-button="false"
      :is-loading="isLoading"
      :descricao="'Buscando'"
    />
    <modal-observacao
      ref="modalObservacao"
      v-model="msgSelecionada"
      :api="apiMensagens"
      :notificar="{ sucesso: notficarSucesso, erro: this.$erro }"
      @change="receberObservacao(props.row)"
      @hidden="fecharObservacao($event)"
    />
  </b-card>
</template>

<style>
.mensagem-tela {
  background-color: #80808036;
  padding: 1rem;
  border-radius: 4px;
  margin: 0.5rem;
}
</style>

<script>
import { abilityValidation } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from '../../services/api'
import colunas from './colunas'

export default {
  name: 'MensagemView',
  components: {
    ModalWhatsapp: () => import('@/app/shared/components/whatsapp/ModalWhatsapp.vue'),
    MensagensList: () => import('@pilar/components/visualizacao-base/VisualizacaoBase.vue'),
    Loading: () => import('@pilar/components/loading/Loading.vue'),
    ModalObservacao: () => import('@/app/shared/components/modal-observacao/ModalObservacao.vue'),
    EnvioEmail: () => import('@/app/shared/components/envio-email/EnvioEmail.vue'),
    ModalCaixaPostal: () => import('@/app/shared/components/modal-caixa-postal/ModalCaixaPostal.vue'),
    FiltroRapido: () => import('@pilar/components/visualizacao-base/components/filtro-rapido/FiltroRapido.vue'),
  },
  data() {
    return {
      abilityUpdate: abilityValidation(10, 3),
      apiMensagens: api,
      nomeEmpresa: '',
      emailEmpresa: [],
      emailAdicionalEmpresa: [],
      idLinha: '',
      botoesOption: null,
      linha: null,
      filtroAtualSecundario: null,
      visualizacao: {
        placeholderBusca: 'Buscar por: Remetente, Assunto, Mensagem ou Data',
        acaoClass: 'caixapostal-td-acao',
        disabledCheckbox: true,
      },
      filtros: [{ colunas: ['Remetente', 'Assunto', 'Mensagem', 'Data', 'ConsultadoEm'], valor: null }],
      filtroRapidoSecundario: [
        {
          id: 'Ate7',
          label: 'Até 7 dias',
          valor: true,
        },
        {
          id: '7a15',
          label: '8 à 15 dias',
          valor: true,
        },
        {
          id: 'Acima15',
          label: 'Acima de 15',
          valor: true,
        },
      ],
      filtrosRapidos: [
        {
          id: 'Pronampe',
          colunas: ['TipoMensagem'],
          label: 'Pronampe',
          valor: '2',
        },
        {
          id: 'MalhaFiscal',
          colunas: ['TipoMensagem'],
          label: 'Malha fiscal',
          valor: '1',
        },
        {
          id: 'TermoIntimacao',
          colunas: ['TipoMensagem'],
          label: 'Termo de intimação',
          valor: '3',
        },
        {
          id: 'TermoIntimacaoNaoLida',
          colunas: ['IntimacaoNaoLida'],
          label: 'Termo(s) de Intimação não lidas',
          valor: true,
        },
        {
          id: 'TermoIntimacaoLida',
          colunas: ['IntimacaoLida'],
          label: 'Termo(s) de Intimação lidas',
          valor: true,
        },
        {
          id: 'TermoExclusao',
          colunas: ['TipoMensagem'],
          label: 'Termo de exclusão',
          valor: '4',
        },
        {
          id: 'TermoIndeferimento',
          colunas: ['TipoMensagem'],
          label: 'Termo de indeferimento',
          valor: '5',
        },
        {
          id: 'Lidas',
          colunas: ['Lidas'],
          label: 'Lidas',
          valor: true,
        },
        {
          id: 'NaoLidas',
          colunas: ['Lidas'],
          label: 'Não lidas',
          valor: false,
        },
        {
          id: 'Relevante',
          colunas: ['Relevante'],
          label: 'Relevantes',
          valor: true,
        },
        {
          id: 'RelevanteNaoLido',
          colunas: ['RelevanteNaoLido'],
          label: 'Relevantes Não Lidas',
          valor: true,
        },
        {
          id: 'EProcesso',
          colunas: ['EProcesso'],
          label: 'e-Processos',
          valor: true,
        },
        {
          id: 'EProcessoNaoLida',
          colunas: ['EProcessoNaoLida'],
          label: 'e-Processos não lidas',
          valor: true,
        },
        {
          id: 'PossuiObservacao',
          colunas: ['PossuiObservacao'],
          label: 'Possui observação',
          valor: true,
        },
        {
          id: 'NovasNoMonitor',
          colunas: ['NovasNoMonitor'],
          label: 'Novas no Monitor',
          valor: false,
        },
      ],
      empresaId: 0,
      isFiltroNovoNoMonitor: false,
      isLoading: false,
      msgSelecionada: {},
    }
  },
  created() {
    this.visualizacao.colunas = colunas
    const col = this.visualizacao.colunas.find(f => f.field === 'assunto')
    col.evento = this.abrirMensagens
    this.visualizacao.evento = this.carregar
    this.empresaId = this.$route.params.id
    this.nomeEmpresa = this.$route.params.nome
  },
  mounted() {
    this.aplicarFiltroQuery()
  },
  updated() {
    this.aplicarFiltroQuery()
  },
  methods: {
    /* eslint-disable no-param-reassign */
    carregar(pagina, tamanhoPagina, filtros) {
      const filtrosBy = filtros.filtroBy || null
      this.ativarFiltroRapidoSecundario(filtrosBy)

      return api.getMensagemPaginado(this.empresaId, pagina, tamanhoPagina, filtros)
    },
    aplicarFiltroQuery() {
      this.$nextTick(() => {
        const params = this.$route.query
        if (params && this.$refs.mensagensList) {
          const filtroRapido = params.filtroRapido
            ? this.filtrosRapidos.find(f => f.id === params.filtroRapido)
            : null
          this.$refs.mensagensList.aplicarFiltro(params.busca, filtroRapido)

          setTimeout(() => {
            this.filtroAtualSecundario = params.dias
              ? this.filtroRapidoSecundario.find(f => f.id === params.dias)
              : null
          }, 300)
        }
      })
    },
    abrirMensagens(row) {
      this.emailEmpresa = row.emailEmpresa
      this.idLinha = row.id
      this.linha = row

      if (row.mensagem) {
        if (row.mensagemLida === false) {
          api.atualizarMensagemLida(row.id)
          this.updateRow(row.id, { mensagemLida: true })
        }
        this.$bvModal.show('m-Mensagens')
      } else {
        this.$confirmar('Mensagem não lida no portal do e-CAC',
          'Você gostaria de ler a mensagem agora? Ao confirmar a leitura será consumido um crédito do seu saldo em conta.')
          .then(confirmado => {
            if (confirmado && confirmado.isConfirmed) {
              this.isLoading = true
              api.getMensagemNaoLida(row.id)
                .then(payload => {
                  const dadosAtualizados = {
                    lido: true,
                    mensagem: payload.data.mensagem.conteudo,
                    dataPrimeiraLeitura: this.formatarData(payload.data.dataPrimeiraLeitura),
                    mensagemLida: true,
                    usuarioAbriu: payload.data.usuarioAbriu,
                    lidoPor: 'Monitor Contábil',
                  }
                  this.updateRow(row.id, dadosAtualizados)
                  // Atualiza a linha que será passada para o modal
                  this.linha = { ...row, ...dadosAtualizados }
                  this.isLoading = false
                  // Aguarda o Vue processar as atualizações reativas antes de abrir o modal
                  this.$nextTick(() => {
                    this.$bvModal.show('m-Mensagens')
                  })
                }).catch(err => {
                  this.isLoading = false
                  const mensagemErro = err?.response?.data?.message || ''

                  if (mensagemErro.toUpperCase().includes('[ACESSONEGADO-ICGERENCIADOR-032]')) {
                    this.$erro('Procuração eletrônica - Empresa apresenta erro com a procuração eletrônica. Verifique e corrija para evitar cobranças indesejadas e erros nas atualizações das rotinas.')
                  } else
                  if (mensagemErro.includes('não tem procuração autorizada no Portal eCAC')) {
                    this.$aviso('Instabilidade com o site de origem, tente novamente mais tarde!')
                  } else
                  if (mensagemErro.includes('Não possui máquina disponível tempo máximo excedido')) {
                    this.$aviso('Não foi possível processar sua solicitação, tente novamente em alguns instantes!')
                  } else
                  if (mensagemErro.includes('Requisição inválida.')) {
                    this.$aviso('Serviço indisponível no momento, por favor, tente novamente em breve!')
                  } else
                  if (mensagemErro.includes('Não possui um certificado digital vinculado.')) {
                    this.$erro('Não possui um certificado digital vinculado.')
                  } else {
                    this.$erro(`Estamos enfrentando problemas técnicos, por favor, tente novamente mais tarde!. Erro: ${mensagemErro}`)
                  }
                })
            }
          })
      }
    },
    formatarData(data) {
      if (data === undefined) {
        return '--'
      }

      const date = new Date(data)
      const dia = String(date.getDate()).padStart(2, '0')
      const mes = String(date.getMonth() + 1).padStart(2, '0')
      const ano = date.getFullYear()
      return `${dia}/${mes}/${ano}`
    },
    atualizaNomeEmpresa(evt) {
      if (!this.nomeEmpresa) {
        this.nomeEmpresa = evt[0].empresa
      }
    },
    openModalEnviarMensagem(row) {
      if (row) {
        this.emailEmpresa = row.emailEmpresa
        this.emailAdicionalEmpresa = row.emailAdicionalEmpresa
        this.idLinha = row.id
      }
      this.$refs.modalEnvioEmail.abrirModal()
    },
    enviarMensagem(itens) {
      if (itens.emailsPara.length === 0 && itens.emailsCc === 0) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Informe ao menos um e-mail',
            icon: 'fa-solid fa-circle-exclamation',
            variant: 'danger',
          },
        })
      } else {
        api.notificaMensagem(this.nomeEmpresa, itens.emailsPara, itens.emailsCc, this.idLinha, itens.mensagensAdicional, itens.definirEmailPadroes)
        this.emailCc = ''
      }
    },
    openModalObservacao(documento) {
      this.msgSelecionada = documento
      this.$nextTick(() => {
        this.$refs.modalObservacao.show()
      })
    },
    fecharObservacao(observacaoNova) {
      const index = this.$refs.mensagensList.gridInfo.dados.findIndex(where => where.id === this.msgSelecionada.id)
      this.$refs.mensagensList.gridInfo.dados[index].temObservacoesNaoLidas = observacaoNova.hasObservacaoNova
      this.$refs.mensagensList.gridInfo.dados[index].todasObservacoesLidas = observacaoNova.observacaoLida
      this.$set(this.msgSelecionada, null)
    },
    notficarSucesso(msg) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: msg,
          icon: 'fa-solid fa-circle-check',
          variant: 'success',
        },
      })
    },
    ativarFiltroRapidoSecundario(filtros) {
      this.isFiltroNovoNoMonitor = filtros?.some(a => a.id === 'NovasNoMonitor') || false
    },
    updateRow(id, changes) {
      const list = this.$refs.mensagensList.gridInfo.dados
      const index = list.findIndex(x => x.id === id)
      if (index !== -1) {
        list[index] = { ...list[index], ...changes }
        this.$refs.mensagensList.gridInfo.dados = [...list]
      }
    },
  },
}

</script>
